import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const n=i("greenland",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.50001H0V18.7693H24V4.50001Z"
                fill="white" />
            <path
                d="M0 11.2845H24V20.5001H0V11.2845ZM4 11.2845C4 12.5638 4.5619 13.7907 5.5621 14.6953C6.56229 15.5999 7.91885 16.1081 9.33333 16.1081C10.7478 16.1081 12.1044 15.5999 13.1046 14.6953C14.1048 13.7907 14.6667 12.5638 14.6667 11.2845C14.6667 10.0052 14.1048 8.77834 13.1046 7.87374C12.1044 6.96914 10.7478 6.46094 9.33333 6.46094C7.91885 6.46094 6.56229 6.96914 5.5621 7.87374C4.5619 8.77834 4 10.0052 4 11.2845Z"
                fill="#C8102E" />
        </svg>
    `),r=i("greenland_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66549)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M26.457 0.387708H-2.46094V22.1395H26.457V0.387708Z"
                    fill="white" />
                <path
                    d="M-2.46094 12.5004H26.457V24.7778H-2.46094V12.5004ZM2.35872 12.5004C2.35872 14.2048 3.03577 15.8393 4.24092 17.0445C5.44607 18.2496 7.0806 18.9266 8.78494 18.9266C10.4893 18.9266 12.1238 18.2496 13.329 17.0445C14.5341 15.8393 15.2112 14.2048 15.2112 12.5004C15.2112 10.7961 14.5341 9.16156 13.329 7.95641C12.1238 6.75126 10.4893 6.07422 8.78494 6.07422C7.0806 6.07422 5.44607 6.75126 4.24092 7.95641C3.03577 9.16156 2.35872 10.7961 2.35872 12.5004Z"
                    fill="#C8102E" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66549">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{n as Greenland,r as GreenlandRounded};
